import { render, staticRenderFns } from "./CollaboratorInfo.vue?vue&type=template&id=60732a45&"
import script from "./CollaboratorInfo.vue?vue&type=script&lang=js&"
export * from "./CollaboratorInfo.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports